// removed by extract-text-webpack-plugin
module.exports = {"container":"container___29APR","header":"header___KyFEa","content":"content___1DTe_","tabTitle":"tabTitle___1VmQz"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ManagerUsers/ManagerUsers.module.css
// module id = 415
// module chunks = 0